import React, { FC } from 'react';
import { Button, Modal } from 'antd';

type PortalSubmissionModalProps = {
    open: boolean;
    title: string;
    handleCancel: (isNoClicked?: boolean) => void;
    handleSave: () => void;
    isLoading?: boolean;
    loading?: boolean;
    setIsSubmitOnPortal?: any;
}
const PortalSubmissionModal: FC<PortalSubmissionModalProps> = (props) => {
  
  return (
    <>
      <Modal
        open={props?.open}
        title={props?.title}
        onCancel={props?.setIsSubmitOnPortal ? props?.setIsSubmitOnPortal : () => { props?.handleCancel(false) }}
        centered
        footer={(_, { OkBtn, CancelBtn }) => (
          <>
            <Button loading={props?.loading} onClick={() => { props?.handleCancel(true) }}>No</Button>
            <Button loading={props?.isLoading} onClick={props?.handleSave}>Yes</Button>
          </>
        )}
      >
      </Modal>
    </>
  );
};

export default PortalSubmissionModal;